import type { Guard } from './index';
import { useAuthStore } from '@/store/auth.store';

export const adminAuth: Guard = (to, from, next) => {
  const authStore = useAuthStore();

  if (authStore.isAdmin()) {
    return next();
  }
  return next({ name: 'Home' });
};
